import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/vercel/path0/src/components/layout/app-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageShell"] */ "/vercel/path0/src/components/layout/page-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaTheme"] */ "/vercel/path0/src/components/meta-theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StructuredData"] */ "/vercel/path0/src/components/seo/structured-data.tsx");
